import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// export const exportToPdf = async (elementId, options = {}) => {
//   const { 
//     filename = 'export.pdf',
//     ignoreElements = [],
//     scale = 2
//   } = options;

//   const element = document.getElementById(elementId);
//   if (!element) {
//     console.error('Element not found');
//     return;
//   }

//   // Hide elements to be ignored
//   ignoreElements.forEach(selector => {
//     const elements = element.querySelectorAll(selector);
//     elements.forEach(el => {
//       el.style.visibility = 'hidden';
//     });
//   });

//   try {
//     const canvas = await html2canvas(element, {
//       scale,
//       useCORS: true,
//       allowTaint: true,
//       logging: false,
//     });

//     const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const imgWidth = 210; // A4 width in mm
//     const pageHeight = 295; // A4 height in mm
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     let heightLeft = imgHeight;
//     let position = 0;

//     pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;

//     while (heightLeft >= 0) {
//       position = heightLeft - imgHeight;
//       pdf.addPage();
//       pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }

//     pdf.save(filename);
//   } catch (error) {
//     console.error('Error generating PDF:', error);
//   } finally {
//     // Restore visibility of ignored elements
//     ignoreElements.forEach(selector => {
//       const elements = element.querySelectorAll(selector);
//       elements.forEach(el => {
//         el.style.visibility = 'visible';
//       });
//     });
//   }
// };


// export const exportToPdf = async (elementId, options = {}) => {
//   const { 
//     filename = 'export.pdf',
//     ignoreElements = [],
//     scale = 2,
//     margin = 10,
//     onError,
//     onStart,
//     onComplete
//   } = options;

//   // Find the element to export
// //   const element = document.getElementById(elementId);
// //   if (!element) {
// //     console.error('Element not found');
// //     return;
// //   }
//   const element = document.getElementById(elementId);
//     if (!element) {
//       if (onError) onError(`Element with ID '${elementId}' not found`);
//       if (onComplete) onComplete();
//       return false;
//     }

//   // Hide elements to be ignored
//   const originalStyles = [];
//   ignoreElements.forEach(selector => {
//     const elements = document.querySelectorAll(selector);
//     elements.forEach(el => {
//       originalStyles.push({
//         element: el,
//         visibility: el.style.visibility,
//         position: el.style.position
//       });
//       el.style.visibility = 'hidden';
//       el.style.position = 'absolute';
//     });
//   });

//   try {
//     const canvas = await html2canvas(element, {
//       scale,
//       useCORS: true,
//       allowTaint: true,
//       logging: false,
//       scrollX: 0,
//       scrollY: -window.scrollY,
//       windowWidth: document.documentElement.offsetWidth,
//       windowHeight: document.documentElement.offsetHeight
//     });

//     const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const imgWidth = 210 - margin * 2; // A4 width in mm minus margins
//     const pageHeight = 295 - margin * 2; // A4 height in mm minus margins
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     let heightLeft = imgHeight;
//     let position = margin;

//     pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;

//     while (heightLeft >= 0) {
//       position = heightLeft - imgHeight + margin;
//       pdf.addPage();
//       pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }

//     pdf.save(filename);
//   } catch (error) {
//     console.error('Error generating PDF:', error);
//   } finally {
//     // Restore visibility and position of ignored elements
//     originalStyles.forEach(style => {
//       if (style.element && style.element.style) {
//         style.element.style.visibility = style.visibility;
//         style.element.style.position = style.position;
//       }
//     });
//   }
// };
export const exportToPdf = async (elementId, options = {}) => {
  const { 
    filename = 'export.pdf',
    ignoreElements = [],
    scale = 3,
    margin = 10,
    isCalendar = false,
    onError,
    onStart,
    onComplete,
    quality = 1,
    autoHeight = false
  } = options;

  if (onStart) onStart();

  const element = document.getElementById(elementId);
  if (!element) {
    if (onError) onError(`Element with ID '${elementId}' not found`);
    if (onComplete) onComplete();
    return false;
  }

  // Create and prepare the clone as before
  const clone = element.cloneNode(true);
  clone.style.position = 'absolute';
  clone.style.left = '-9999px';
  clone.style.top = '0';
  clone.style.width = `${element.offsetWidth}px`;
  clone.style.height = 'auto';
  document.body.appendChild(clone);

  ignoreElements.forEach(selector => {
    const elements = clone.querySelectorAll(selector);
    elements.forEach(el => {
      el.style.visibility = 'hidden';
      el.style.position = 'absolute';
    });
  });

  try {
    const canvas = await html2canvas(clone, {
      scale,
      useCORS: true,
      allowTaint: true,
      logging: false,
      scrollX: 0,
      scrollY: 0,
      windowWidth: clone.scrollWidth,
      windowHeight: clone.scrollHeight,
      backgroundColor: isCalendar ? null : '#ffffff',
      quality,
      letterRendering: true,
      removeContainer: true
    });

    const imgWidth = isCalendar ? 297 - margin * 2 : 210 - margin * 2;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    // Initialize PDF without creating a page
    const pdf = new jsPDF({
      orientation: isCalendar ? 'landscape' : 'portrait',
      unit: 'mm',
      compress: true,
      precision: 16
    });

    if (autoHeight) {
      const pageHeight = imgHeight + margin * 2;
      const pageWidth = imgWidth + margin * 2;
      
      // Remove the default empty page
      pdf.deletePage(1);
      
      // Add a new page with our custom dimensions
      pdf.addPage([pageWidth, pageHeight], isCalendar ? 'landscape' : 'portrait');
      
      pdf.addImage(canvas.toDataURL('image/jpeg', quality), 'JPEG', 
        margin, margin, imgWidth, imgHeight, 
        undefined, 'FAST');
    } else {
      pdf.addImage(canvas.toDataURL('image/jpeg', quality), 'JPEG', 
        margin, margin, imgWidth, imgHeight, 
        undefined, 'FAST');
    }

    pdf.save(filename);
    return true;
  } catch (error) {
    console.error('Error generating PDF:', error);
    if (onError) onError('Failed to generate PDF. Please try again.');
    return false;
  } finally {
    if (clone.parentNode) {
      clone.parentNode.removeChild(clone);
    }
    if (onComplete) onComplete();
  }
};